import classNames from 'classnames';

const ResponsiveCircle = ({ className }: { className?: string }) => {
  return (
    <div className={classNames(className, 'flex h-screen items-center justify-center')}>
      <div
        className={`3xl:bg-blue-500 4xl:bg-teal-500 5xl:bg-indigo-500 flex size-8 items-center justify-center rounded-full bg-green-300 text-xs font-bold text-white xs:bg-green-500 sm:bg-yellow-500 md:bg-orange-500 lg:bg-red-500 xl:bg-purple-500 2xl:bg-pink-500`}
      >
        <span className="block xs:hidden">-</span>
        <span className="hidden xs:block sm:hidden">XS</span>
        <span className="hidden sm:block md:hidden">SM</span>
        <span className="hidden md:block lg:hidden">MD</span>
        <span className="hidden lg:block xl:hidden">LG</span>
        <span className="hidden xl:block 2xl:hidden">XL</span>
        <span className="3xl:hidden hidden 2xl:block">2XL</span>
        <span className="3xl:block 4xl:hidden hidden">3XL</span>
        <span className="4xl:block 5xl:hidden hidden">4XL</span>
        <span className="5xl:block hidden">5XL</span>
      </div>
    </div>
  );
};

export const ResponsiveContainerCircle = ({ className }: { className?: string }) => {
  return (
    <div
      className={classNames(
        className,
        'absolute left-1/2 top-0 flex h-screen translate-x-1/2 items-center justify-center'
      )}
    >
      <div
        className={`z-[60] flex size-8 min-w-8 items-center justify-center rounded-full bg-green-300 text-xs font-bold text-white @xs:bg-green-500 @sm:bg-yellow-500 @md:bg-orange-500 @lg:bg-red-500 @xl:bg-purple-500 @2xl:bg-pink-500 @3xl:bg-blue-500 @4xl:bg-teal-500 @5xl:bg-indigo-500`}
      >
        <span className="block @xs:hidden">-</span>
        <span className="hidden @xs:block @sm:hidden">xs</span>
        <span className="hidden @sm:block @md:hidden">sm</span>
        <span className="hidden @md:block @lg:hidden">md</span>
        <span className="hidden @lg:block @xl:hidden">lg</span>
        <span className="hidden @xl:block @2xl:hidden">xl</span>
        <span className="hidden @2xl:block @3xl:hidden">2xl</span>
        <span className="hidden @3xl:block @4xl:hidden">3xl</span>
        <span className="hidden @4xl:block @5xl:hidden">4xl</span>
        <span className="hidden @5xl:block">5xl</span>
      </div>
    </div>
  );
};

export default ResponsiveCircle;
